import React from 'react';
import Modal from 'react-modal';
import { useLanguage } from '../i18n';

Modal.setAppElement('#root');

const FreeExportsExhaustedModal = ({ open, onClose }) => {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentLabel={t('freeExportsExhausted')}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '500px',
          width: '90%'
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 10000
        }
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '20px', color: '#d32f2f' }}>
          {t('freeExportsExhausted')}
        </h2>
        
        <div style={{ marginBottom: '20px', textAlign: 'left' }}>
          <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
            {t('freeExportsExhaustedMessage')}
          </p>
          
          <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
            {t('freeExportsContactMessage')}
          </p>
          
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '15px',
            borderRadius: '4px',
            marginTop: '20px'
          }}>
            <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              {t('contactInformation')}:
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>{t('email')}:</strong> info@flightsafe.se
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>{t('address')}:</strong> www.flightsafe.se
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          style={{
            padding: '10px 30px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer',
            marginTop: '10px'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1565c0'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#1976d2'}
        >
          {t('close')}
        </button>
      </div>
    </Modal>
  );
};

export default FreeExportsExhaustedModal;
